module.exports = __webpack_public_path__ + "static/img/kjdy21.bca7f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy21.png
// module id = 337
// module chunks = 0